import { render } from "./Brand.vue?vue&type=template&id=0bf46afc&scoped=true"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"

import "./Brand.vue?vue&type=style&index=0&id=0bf46afc&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-0bf46afc"

export default script